<template>
  <span class="sort-select">
    <i class="fa fa-sort-amount-asc"></i>
    <select :id="id" class="form-control form-control-sm" :value="value" @change="$emit('input', $event.target.value)" aria-label="ترتيب القائمة">
      <option v-for="c in choices" :key="c.value" :value="c.value">{{ c.text }}</option>
    </select>
  </span>
</template>

<script>
// «ترتيب» for every list of students / teachers: name A→Z / Z→A, or by grade and class in school order.
// v-model gives '' (the page's own order) or name_asc | name_desc | class_asc | class_desc; sort the
// page's FULL list with sort_rows from @/libs/list-sort (or send `sort` to /user/students/list, which
// sorts on the server before paging). `no-class` hides the class choices (e.g. teachers).
import { CHOICES } from '@/libs/list-sort'

export default {
  name: 'SortSelect',
  props: {
    value: { type: String, default: '' },
    noClass: { type: Boolean, default: false },
    id: { type: String, default: null },
  },
  computed: {
    choices() {
      return this.noClass ? CHOICES.filter(function(c) { return !c.value.startsWith('class'); }) : CHOICES;
    },
  },
}
</script>

<style scoped>
.sort-select { display: inline-flex; align-items: center; gap: 6px; }
.sort-select select { width: auto; min-width: 170px; }
.sort-select .fa { color: #7367f0; }
</style>
